import ServiceBase from './ServiceBase';

export default class AuthenticationService extends ServiceBase {
    async login(values) {
        var authResult = await this.requestJson({
            url: "api/user/authenticate",
            method: "POST",
            data: values
        });

        return authResult;
    }

    async getUser(fingerprint) {
        var result = await this.requestJson({
            url: "api/user/persistauth",
            method: "GET",
            data: fingerprint
        })

        return result;
    }

    async logout() {
        var result = await this.requestJson({
            url: "api/user/logout",
            method: "GET"
        });
        return result;
    }

    async changePasswordAndAuthenticate(values) {
        var authResult = await this.requestJson({
            url: "api/user/password/auth",
            method: "POST",
            data: values
        });
        return authResult;
    }
}